import React from 'react';
import ManageEntityList from './ManageEntityList';
import { useHeight } from '../../Services/HeightContext';
import entities from '../../utils/entities';
import ClientModal from '../Models/ClientModal';
import { Route } from 'react-router-dom';
import AdminDetail from '../Editors/AdminDetail';


const ManageAdmins = ({ route,isNewItem }) => {
    const [height] = useHeight();
    return <React.Fragment>
        <ManageEntityList route={'/manageAdmins'} parentHeight={height} entity={entities.admins} />
            <Route path='/manageAdmins/:adminId' render={() => <ClientModal entity={entities.admins} route={route} itemParam='adminId'><AdminDetail invite={isNewItem} route={route} />
        </ClientModal>} />
    </React.Fragment>

}
export default ManageAdmins;

